export default __webpack_public_path__ + "static/new-italia-1-169d7104544f148021bec860db065080.jpg";